<template>
  <div>
    <div class="app-top">
      <top-title :dataList="topTitleList" :height="300"></top-title>
    </div>
    <div class="container">
      <div class="my-p-t-40 my-p-b-20">
        <versions-buy />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import topTitle from '@/_myComponents/topTitle'
import versionsBuy from './components/versionsBuy'
export default {
  components: { topTitle, versionsBuy },
  name: 'NetworkPrice',
  data() {
    return {
      loading: false,
      topTitleList: []
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['softPrice'])
  },
  mounted() {},
  created() {
    this.utils.refreshSoftPrice(this.onloadArgs.getInvite())
    this.topTitleList = [
      {
        image: '',
        title: '网络版',
        subTitle: '多个版本，按需选择；云端同步，手机+电脑',
        backgroundImage: require('@/assets/images/bg/bg-5.jpg'),
        backgroundColor: `linear-gradient(rgba(${this.utils.hexToRgb(this.softPrice.softThemeColor)},0.5),rgba(${this.utils.hexToRgb(
          this.softPrice.softThemeColor
        )},0.1))`
      }
    ]
  },
  methods: {
    clickBuy(licenseType) {
      console.log(licenseType)
      if (licenseType == 'Network') {
        this.$router.push({ name: 'BuyNetwork' })
      } else {
        this.$router.push({ name: 'BuyAlone', params: { licenseType: licenseType } })
      }
      // this.$router.push({ name: 'Buy', params: { licenseType: licenseType } })
    },
    goUrl(url) {
      window.open(url, '_blank ')
    }
  }
}
</script>

<style lang="scss" scoped>
// --------------------移动端--------------------
@media screen and (max-width: 576px) {
  .container {
    font-size: 12px;
  }
}

// --------------------电脑端--------------------
.app-top {
  margin-top: 58px;
}

.container {
  background: #f8f8f8;
}
</style>